import script from "./DragUploadOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./DragUploadOverlay.vue?vue&type=script&setup=true&lang=js"

import "./DragUploadOverlay.vue?vue&type=style&index=0&id=7fdf14dc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fdf14dc"]])

export default __exports__